export const GET_RESE_COMMAND_DIVISION_DETAILS = {
  INIT: "GET_RESE_COMMAND_DIVISION_DETAILS_INIT",
  SUCCESS: "GET_RESE_COMMAND_DIVISION_DETAILS_SUCCESS",
  ERROR: "GET_RESE_COMMAND_DIVISION_DETAILS_ERROR",
};

export const RESE_POST_CREATE_JOB = {
  INIT: "RESE_POST_CREATE_JOB_INIT",
  SUCCESS: "RESE_POST_CREATE_JOB_SUCCESS",
  ERROR: "RESE_POST_CREATE_JOB_ERROR",
};

export const POST_EXECUTE_NOW_JOB = {
  INIT: "POST_EXECUTE_NOW_JOB_INIT",
  SUCCESS: "POST_EXECUTE_NOW_JOB_SUCCESS",
  ERROR: "POST_EXECUTE_NOW_JOB_ERROR",
};

export const RESE_GET_JOB_DETAILS = {
  INIT: "RESE_GET_JOB_DETAILS_INIT",
  SUCCESS: "RESE_GET_JOB_DETAILS_SUCCESS",
  ERROR: "RESE_GET_JOB_DETAILS_ERROR",
};

export const RESET_RESE_CREATE_JOB_SUCCESS_MESSAGE =
  "RESET_RESE_CREATE_JOB_SUCCESS_MESSAGE";

export const RESET_EXECUTE_NOW_JOB_SUCCESS_MESSAGE =
  "RESET_EXECUTE_NOW_JOB_SUCCESS_MESSAGE";

export const GET_RESE_SERVER_DETAILS_BY_JOB_ID = {
  INIT: "GET_RESE_SERVER_DETAILS_BY_JOB_ID_INIT",
  SUCCESS: "GET_RESE_SERVER_DETAILS_BY_JOB_ID_SUCCESS",
  ERROR: "GET_RESE_SERVER_DETAILS_BY_JOB_ID_ERROR",
};

export const CANCEL_RESE_GRAFANA_AGENT_REMOTE_COMMAND_SCHEDULE = {
  INIT: "CANCEL_RESE_GRAFANA_AGENT_REMOTE_COMMAND_SCHEDULE_INIT",
  SUCCESS: "CANCEL_RESE_GRAFANA_AGENT_REMOTE_COMMAND_SCHEDULE_SUCCESS",
  ERROR: "CANCEL_RESE_GRAFANA_AGENT_REMOTE_COMMAND_SCHEDULE_ERROR",
};

export const SET_RESE_MODIFY_JOB_DETAILS = "SET_RESE_MODIFY_JOB_DETAILS";

export const RESET_RESE_MODIFY_JOB_DETAILS = "RESET_RESE_MODIFY_JOB_DETAILS";

export const SET_RESE_CLONE_JOB_DETAILS = "SET_RESE_CLONE_JOB_DETAILS";

export const RESET_RESE_CLONE_JOB_DETAILS = "RESET_RESE_CLONE_JOB_DETAILS";

export const SET_SORTING = 'SET_SORTING';
export const SET_FILTERS = 'SET_FILTERS';
